/**
 * ERC Different Unit Value Validator Adapter for DRC System
 *
 * This validator checks for multi-unit components where units have different values.
 *
 * Note: This validator requires value data which is not currently available
 * in IPartVersionData. Returns empty results until value data is added.
 *
 * Feature-gated via DrcEnabledCheckers.ErcDifferentUnitValueValidator
 */
import { ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
/**
 * Validator that checks for different values in multi-unit components.
 */
export class ErcDifferentUnitValueValidator {
    reviewType = ReviewType.DesignRuleCheckErcDifferentUnitValue;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems(_inputs) {
        const foundProblems = [];
        // Note: This validator requires value data which is not currently
        // available in IPartVersionData. Returns empty results until value data is added.
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcDifferentUnitValueValidator.js.map